import { MapTo } from '@adobe/aem-react-editable-components';
import ProgressBar, { ProgressBarEditConfig } from './ProgressBar';

export default MapTo('cob-corp-acquisition/components/creditonebank/progress-bar')(ProgressBar, ProgressBarEditConfig);